
<template>
  <div class="rj-bottom_btn" :class="isCollapse ? 'collapse' : ''">
    <el-button size="medium" :loading="loading" @click="handleCancel">
      返回
    </el-button>
    <template v-if="isApprove">
      <el-button size="medium" :loading="loading" @click="handleReject">
        驳回
      </el-button>
      <el-button type="primary" size="medium" :loading="loading" @click="handlePass">
        通过
      </el-button>
    </template>
    <template v-if="isApply">
      <el-button type="primary" :loading="loading" size="medium" @click="handleSubmit">
        提交
      </el-button>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'BottomButtonGroup',
  // 驳回，取消，提交, 通过
  emits: ['reject', 'submit', 'pass', 'cancel'],
  props: {
    // isLoading
    loading: {
      type: Boolean,
      default: false
    },
    // 审批
    isApprove: {
      type: Boolean,
      default: false
    },
    // 编辑
    isApply: {
      type: Boolean,
      default: false
    },
    // 详情
    isDetail: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState(['isCollapse'])
  },
  methods: {
    // 返回 ,取消
    handleCancel () {
      this.$emit('cancel');
    },
    // 驳回
    handleReject () {
      this.$emit('reject');
    },
    // 提交
    handleSubmit () {
      this.$emit('submit');
    },
    // 通过
    handlePass () {
      this.$emit('pass');
    }
  }
};
</script>

<style scoped lang="scss">

// 底部按钮
.rj-bottom_btn {
  z-index: 998;
  width: calc(100% - 230px);
  height: 60px;
  position: fixed;
  bottom: 0;
  right: 0;
  left: 230px;
  background-color: rgba(255, 255, 255, 1);
  font-size: 14px;
  box-shadow: 0 -4px 10px 0 rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 18px;
  transition: width 0.3s ease-in-out, left 0.3s ease-in-out;
  &.collapse{
    width: calc(100% - 64px);
    left: 64px;
  }
  :deep(.el-button) {
    min-width: 120px;
    height: 42px;
    font-size: 16px;
    margin-left: 0;
  }
}
</style>
